import React from "react";
import PATHS from "config/paths";

export function useGetVictim(token, id = undefined, refresh = false, is_archived = false) {
  const [victim, setVictim] = React.useState();
  const [error, setError] = React.useState();

  const handleResponse = (data) => {
    if (data) {
      setVictim(data);
    } else {
      setError(new Error("data-data"));
    }
  };

  React.useEffect(() => {
    if ((token && id && !victim) || (token && id && refresh)){
      const headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", `Bearer ${token}`);
      const options = {
        method: "GET",
        headers: headers,
        redirect: "follow",
        cache: "no-cache",
      };

      // Make request
      const url = is_archived ? `${PATHS.apiVictims}/${id}?is_archived=true` : `${PATHS.apiVictims}/${id}`;
      fetch(url, options)
        .then((response) => response.text())
        .then((result) => handleResponse(JSON.parse(result)))
        .catch((error) => console.warn("error", error));
    }
  }, [token, id, victim, refresh]);

  return { victimGet: victim, victimError: error };
}
